export const HEADER_COLOR = '#D3D3D3';
export const PAGE_BORDER_WIDTH = 6;
export const FULL_WIDTH = 216 - PAGE_BORDER_WIDTH * 2;
export const FULL_HEIGHT = 279 - PAGE_BORDER_WIDTH;
export const SECTION_GAP_WIDTH = 3;
export const COLUMN_GAP_WIDTH = 10;
export const LINE_Y_OFFSET = 0.5;
export const HEADER_HEIGHT = 24;
export const HEADER_WIDTH = FULL_WIDTH;
export const HEADER_LEFT = PAGE_BORDER_WIDTH;
export const HEADER_TOP = PAGE_BORDER_WIDTH;
export const ROW_SECTION_HEADER_HEIGHT = 4;
export const THIN_LINE = 0.25;
export const THICK_LINE = 0.5;

export const HEADER_1_SIZE = 9;
export const HEADER_2_SIZE = 7;
export const LOGO_LEFT = PAGE_BORDER_WIDTH;
export const LOGO_TOP = PAGE_BORDER_WIDTH;
export const LOGO_WIDTH = 50;
export const LOGO_HEIGHT = 23;

export const TENANT_INFO_TOP = PAGE_BORDER_WIDTH + 2;
export const TENANT_INFO_LEFT = PAGE_BORDER_WIDTH + LOGO_WIDTH + SECTION_GAP_WIDTH;
export const TENANT_INFO_WIDTH = FULL_WIDTH - LOGO_WIDTH - SECTION_GAP_WIDTH;
export const TENANT_INFO_HEIGHT = 20;

export const SUB_HEADER_TOP = HEADER_TOP + HEADER_HEIGHT + ROW_SECTION_HEADER_HEIGHT;
export const SUB_HEADER_LEFT = PAGE_BORDER_WIDTH;
export const SUB_HEADER_WIDTH = FULL_WIDTH;
export const SUB_HEADER_HEIGHT = 20;

export const DATA_TOP = SUB_HEADER_TOP + SUB_HEADER_HEIGHT + SECTION_GAP_WIDTH;
export const DATA_HEIGHT = FULL_HEIGHT - DATA_TOP - PAGE_BORDER_WIDTH;
export const DATA_LEFT = PAGE_BORDER_WIDTH;

export const COLUMN_TWO_LEFT = PAGE_BORDER_WIDTH + (FULL_WIDTH - COLUMN_GAP_WIDTH) / 2 + COLUMN_GAP_WIDTH;
export const COLUMN_WIDTH = (FULL_WIDTH - COLUMN_GAP_WIDTH) / 2;
export const ROW_HEIGHT = 5;



// WEBPACK FOOTER //
// ./src/Services/Pdf/OperatorPriceList/SpecMilsOperatorPriceList.ts